import * as React from 'react';

import { observer } from 'mobx-react';

import { IContext } from '@estee/elc-form/typings/views/Form';

import { getDaysInMonth } from '~utils/Date';
import { buildNumericDropdownOptions } from '~utils/DropDownUtils';

import { DropDown, IDropDownProps } from './DropDown';

export interface IDateDayProps extends Omit<IDropDownProps, 'options'> {
    monthFieldName?: string;
    yearFieldName?: string;
}

@observer
export class DateDay extends React.Component<IDateDayProps> {
    public static contextTypes = {
        form: () => null
    };

    public render() {
        const { form } = this.context as IContext;
        const { yearFieldName, monthFieldName, name } = this.props;
        const dayValue = form.values[name];
        const monthValue = monthFieldName ? form.values[monthFieldName] : undefined;
        const yearValue = yearFieldName ? form.values[yearFieldName] : undefined;
        const endDay = getDaysInMonth(yearValue, monthValue);
        if (dayValue && parseInt(dayValue, 10) > endDay) {
            form.onDropDownChange(name, endDay.toString());
        }
        const birthDayDropdownOptions = buildNumericDropdownOptions(1, endDay);
        const propsWithOptions = {
            ...this.props,
            options: birthDayDropdownOptions
        };

        return <DropDown {...propsWithOptions} />;
    }
}
